import {
  BenefitsValueObjectsBenefitMembersMemberTypeEnum,
  BenefitsValueObjectsBenefitStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

/**
 * Get translated label for enrollment status
 */
export const getStatusLabel = (status: BenefitsValueObjectsBenefitStatusEnum): string => {
  switch (status) {
    case 'active':
      return i18n.t('benefits.healthcare.enrollment.status.active')
    case 'pending':
      return i18n.t('benefits.healthcare.enrollment.status.pending')
    case 'requested':
      return i18n.t('benefits.healthcare.enrollment.status.requested')
    case 'inactive':
      return i18n.t('benefits.healthcare.enrollment.status.inactive')
    default:
      return status
  }
}

/**
 * Get translated label for relationship to employee
 */
export const getRelationshipLabel = (
  relationship: BenefitsValueObjectsBenefitMembersMemberTypeEnum
): string => {
  if (!relationship) {
    return '-'
  }

  switch (relationship) {
    case 'employee':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.employee')
    case 'spouse':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.spouse')
    case 'child':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.child')
    case 'partner':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.partner')
    case 'other_family':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.other_family')
    case 'other_non_family':
      return i18n.t('benefits.healthcare.management.filters.member_type.options.other_non_family')
    default:
      return relationship
  }
}

/**
 * Get visual variant for enrollment status badge
 * Maps backend status values to OneDataCollection status variants
 * @param status - Backend status: pending, requested, active, inactive
 * @returns Status variant: positive, warning, info, critical, neutral
 */
export const getStatusVariant = (
  status: BenefitsValueObjectsBenefitStatusEnum
): 'positive' | 'warning' | 'info' | 'critical' | 'neutral' => {
  switch (status) {
    case 'active':
      return 'positive'
    case 'pending':
      return 'warning'
    case 'requested':
      return 'info'
    case 'inactive':
      return 'critical'
    default:
      return 'neutral'
  }
}
